<template>
  <div
    v-if="election && candidates"
    v-on:lock="noScroll()"
    v-on:unlock="scroll()"
    @keydown.tab="handleContestTabNavigation($event)"
    id="election-modal2"
  >
    <md-progress-bar md-mode="indeterminate" v-show="!loaded"></md-progress-bar>
    <!-- Alert per pari opportunità -->
    <div
      class="title-alert"
      v-if="
        electionType &&
          electionType.indexOf('EQUAL_OPPORTUNITIES') !== -1 &&
          listOrCandidates === 'CANDIDATES'
      "
    >
      <b v-if="electionType == 'AIDED_EQUAL_OPPORTUNITIES'">
        {{ $t("election.aided-equal-opportunities-alert") }}</b
      >
      <span v-if="electionType == 'AIDED_THREE_EQUAL_OPPORTUNITIES'">
        {{ $t("election.aided-three-equal-opportunities-alert") }}</span
      >
    </div>
    <div
      class="md-layout md-layout-item md-size-100 mg content-light-w"
      style="margin:0"
    >
      <div v-if="election && candidates" class="fullsize">
        <div v-if="candidates.length > 20" class="input-focus">
          <div
            class="search-w no-selection "
            v-bind:class="showAll ? 'disabled' : ''"
          >
            <input
              type="text"
              id="kinput"
              :placeholder="$t('election-mobile.input-box.search')"
              :value="typeahead"
              @input="evt => (typeahead = evt.target.value)"
              @keydown.enter="hideKeyboard()"
              @keyup="scrollToElement({ behavior: 'auto', block: 'start' })"
              :disabled="showAll"
              :aria-disabled="showAll"
              autocomplete="off"
            />
            <md-icon style="float:right;">search</md-icon>
          </div>

          <div class="check-w">
            <md-switch
              v-model="showAll"
              @change="mostraTutti"
              :aria-label="$t('election-mobile.input-box.show-all')"
              role="switch"
              :aria-checked="showAll"
              >{{ $t("election-mobile.input-box.show-all") }}</md-switch
            >
          </div>
        </div>
        <div
          v-if="pages.length > 1"
          class="num-page-top"
          aria-live="assertive"
          :aria-label="
            listOrCandidates === 'CANDIDATES'
              ? $t('election-mobile.pagination.candidates-pagination-label') +
                page +
                ' ' +
                $t('election-mobile.pagination.of') +
                ' ' +
                pages.length
              : $t('election-mobile.pagination.affiliations-pagination-label') +
                page +
                ' ' +
                $t('election-mobile.pagination.of') +
                ' ' +
                pages.length
          "
          :key="refreshPageTopKey"
        >
          {{ $t("election-mobile.pagination.page") }} {{ page }}
          {{ $t("election-mobile.pagination.of") }} {{ pages.length }}
        </div>
        <span v-if="pages.length > 1" class="screenreader">{{
          $t("election-mobile.screen-reader.pagination")
        }}</span>
        <div
          class="md-layout-item md-size-100 fullsize"
          :id="
            candidate.CandidateIdentifier
              ? candidate.CandidateIdentifier.Id + '-ext'
              : candidate.AffiliationIdentifier.Id + '-ext'
          "
          v-for="candidate in displayedPosts"
          :key="
            candidate.CandidateIdentifier
              ? candidate.CandidateIdentifier.Id
              : candidate.AffiliationIdentifier.Id
          "
        >
          <div v-if="listOrCandidates === 'CANDIDATES'">
            <candidate
              :candidate="candidate"
              @candidateSelected="candidateSelected"
              :disabled="tooMany"
              class="fullsize"
              :previousVoted="voted"
              :sexVoted="sexVoted"
            >
            </candidate>
          </div>
          <div v-if="listOrCandidates === 'AFFILIATIONS'">
            <affiliation
              :affiliation="candidate"
              @affiliationSelected="affiliationSelected"
              @affiliationConfirmed="affiliationConfirmed"
              v-show="listOrCandidates === 'AFFILIATIONS'"
              :disabled="tooMany"
              :electionType="electionType"
              class="fullsize no-gutter"
              :sexVoted="sexVoted"
              :previousVoted="listVoted"
              :electionName="
                election.Election[0].ElectionIdentifier.ElectionName
              "
            >
            </affiliation>
          </div>
        </div>
      </div>
      <!-- paginazione -->
      <nav
        :aria-label="$t('election-mobile.pagination.navigation')"
        v-if="pages.length > 1"
        class="paginator"
      >
        <div class="num-page" :key="refreshPageKey">
          {{ $t("election-mobile.pagination.page") }} {{ page }}
          {{ $t("election-mobile.pagination.of") }} {{ pages.length }}
        </div>
        <ul class="pagination">
          <li class="page-item">
            <md-button
              type="button"
              class="page-link"
              :disabled="page == 1"
              :aria-label="$t('election-mobile.pagination.previous-page')"
              :aria-disabled="page == 1"
              @click="
                page--;
                pageChanged = true;
                readPageFocus(false);
              "
            >
              &lt; {{ $t("election-mobile.pagination.previous-button") }}
            </md-button>
          </li>
          <li class="page-item">
            <md-button
              type="button"
              @click="
                page++;
                pageChanged = true;
                readPageFocus(true);
              "
              :disabled="page == pages.length"
              class="page-link"
              :aria-label="$t('election-mobile.pagination.next-button')"
              :aria-disabled="page == pages.length"
            >
              {{ $t("election-mobile.pagination.next-button") }} &gt;
            </md-button>
          </li>
        </ul>
      </nav>
    </div>
    <div class="toolbar md-layout md-layout-item md-size-100 md-layout">
      <span
        tabindex="0"
        class="md-layout-item md-size-100 md-caption mg preferenze-label "
        v-if="listOrCandidates == 'CANDIDATES'"
        :aria-label="
          $t(
            'election-mobile.screen-reader.candidates.max-preference-summary'
          ) +
            election.Election[0].MaxVotes +
            $t(
              'election-mobile.screen-reader.candidates.selected-preference-summary'
            ) +
            voted.length
        "
      >
        <!--aria-live="assertive"-->
        {{ $t("election.preferences.candidates.max-number") }}:
        {{ election.Election[0].MaxVotes }}<br />
        {{ $t("election.preferences.candidates.selected-number") }}:
        {{ voted.length }}
      </span>
      <span
        class="md-layout-item  md-size-100 md-caption mg preferenze-label"
        v-if="listOrCandidates == 'AFFILIATIONS'"
        :aria-label="
          $t(
            'election-mobile.screen-reader.affiliations.max-preference-summary'
          ) +
            election.Election[0].MaxVotes +
            $t(
              'election-mobile.screen-reader.affiliations.selected-preference-summary'
            ) +
            listVoted.length
        "
      >
        <!--:aria-live="hasPreferences && !readAriaLive ? 'off' : 'assertive'"-->
        {{ $t("election.preferences.affiliations.max-number") }}:
        {{ election.Election[0].MaxVotes }}<br />
        {{ $t("election.preferences.affiliations.selected-number") }}:
        {{ listVoted.length }}
      </span>

      <div
        class="md-layout-item "
        :class="
          election.Election[0].NullChoiceIdentifier ? 'md-size-50' : 'size-50'
        "
      >
        <md-button
          tabindex="-1"
          @click="
            voteBlank = true;
            openFinalConfirm = true;
            lastClick();
          "
          class="md-raised  md-mini md-accent"
          :disabled="!loaded || atLeastOne || openFinalConfirm || voteSent"
          :aria-disabled="!loaded || atLeastOne || openFinalConfirm || voteSent"
        >
          <md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="tooltip"
            >{{ $t("election.blank-button") }}
          </md-tooltip>
          {{
            $i18n.locale == "it"
              ? election.Election[0].NoChoiceIdentifier.Value
              : $t("election.blank-button")
          }}
        </md-button>
      </div>
      <div
        class="md-layout-item  md-size-50"
        v-if="election.Election[0].NullChoiceIdentifier"
      >
        <md-button
          tabindex="-1"
          @click="
            voteNull = true;
            openFinalConfirm = true;
            lastClick();
          "
          class="md-raised md-mini md-accent"
          :disabled="!loaded || atLeastOne || openFinalConfirm || voteSent"
          :aria-disabled="!loaded || atLeastOne || openFinalConfirm || voteSent"
        >
          <md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="tooltip"
            >{{ $t("election.null-button") }}
          </md-tooltip>
          {{
            $i18n.locale == "it"
              ? election.Election[0].NullChoiceIdentifier.Value
              : $t("election.null-button")
          }}
        </md-button>
      </div>
      <div
        class="md-layout-item vota-container"
        :class="
          election.Election[0].NullChoiceIdentifier ? 'md-size-50' : 'size-50'
        "
      >
        <md-button
          tabindex="-1"
          id="vote"
          @click="lastClickVote"
          class="md-raised md-primary md-mini vota"
          :disabled="!ready || openFinalConfirm || voteSent"
          :aria-disabled="!ready || openFinalConfirm || voteSent"
        >
          <md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="tooltip"
            >{{ $t("election.vote-button") }}
          </md-tooltip>
          {{ $t("election.vote-button") }}
        </md-button>
      </div>
    </div>

    <no-all-preference-dialog
      @opened="noScroll()"
      @closed="scroll()"
      :confirmVoteDialog="confirmVoteDialog"
      @openFinalConfirm="
        openFinalConfirm = true;
        confirmVoteDialog = false;
      "
      @cancel="confirmVoteDialog = false"
    ></no-all-preference-dialog>
    <!-- <confirm-null-vote-dialog
      :confirmBlank="confirmBlank"
      @openFinalConfirm="
        openFinalConfirm = true;
        confirmBlank = false;
      "
      @cancel="confirmBlank = false"
    ></confirm-null-vote-dialog>
    <confirm-real-null-vote-dialog
      :confirmNull="confirmNull"
      @openFinalConfirm="
        openFinalConfirm = true;
        confirmNull = false;
      "
      @cancel="confirmNull = false"
    ></confirm-real-null-vote-dialog>-->
    <final-confirm-vote
      :openFinalConfirm="openFinalConfirm"
      :listOrCandidates="listOrCandidates"
      :voted="voted"
      :listVoted="listVoted"
      :voteBlank="voteBlank"
      :voteNull="voteNull"
      :hasPreferences="hasPreferences"
      @finalConfirmationVote="
        $emit('scheda-urna');
        finalConfirmationVote();
      "
      @finalConfirmationCancel="
        finalConfirmationCancel();
        finalConfirmCancel = true;
      "
      @opened="noScroll()"
      @closed="scroll()"
      style="overflow:scroll;"
    >
    </final-confirm-vote>
    <!-- <abstention-dialog
      :confirmAbstention="confirmAbstention"
      @cancel="confirmAbstention = false"
      @abstention="
        confirmAbstention = false;
        makeAbstention();
      "
    > -->
    <!-- <equal-opp-dialog
      :confirmEqual="(sexVoted == 1 || sexVoted == -1) && confirmEqual"
      three="electionType !== 'AIDED_EQUAL_OPPORTUNITIES'"
      @cancel="confirmEqual = false"
      @opened="noScroll()"
      @closed="scroll()"
    >
    </equal-opp-dialog> -->
  </div>
</template>

<script>
import ElectionMixin from "./ElectionLogicMixin";
import MobileMixin from "./MobileLogicMixin";
import Candidate from "./Candidate";
import Affiliation from "./Affiliation";
import Utils from "../utils/Utils.js";
import NoAllPreferenceDialog from "./NoAllPreferenceDialog";
//import EqualOppDialog from "./EqualOppDialog";

import FinalConfirmVote from "./FinalConfirmVote";

import { isMobile } from "mobile-device-detect";

export default {
  mixins: [ElectionMixin, MobileMixin],
  mounted() {
    this.isMobile = isMobile;
    //console.log("xxx ~ this.isMobile: election mobile", this.isMobile);
    this.utils = new Utils();
    this.$root.$on("lock", () => {
      this.noScroll();
    });
    this.$root.$on("unlock", () => {
      this.scroll();
    });
    this.getElection();
  },
  data: function() {
    return {
      utils: null,
      election: null,
      electionType: null,
      listOrCandidates: null,
      candidates: [],
      voted: [],
      listVoted: [],
      ready: false,
      atLeastOne: false,
      tooMany: false,
      contestNames: {},
      confirmVoteDialog: false,
      // confirmBlank: false,
      // confirmNull: false,
      voteBlank: false,
      voteNull: false,
      confirmAbstention: false,
      openFinalConfirm: false,
      signatureTemplate: null,
      loaded: false,
      typeahead: "",
      showAll: false,
      equalOpps: false,
      confirmEqual: true,
      isMobile: true,
      voteSent: false,
      totCandidatesOrAffiliations: 0,
      finalConfirmCancel: false,
      lastEqOppFocus: "",
      lastVoteFocus: "",
      page: 1,
      perPage: 100,
      pages: [],
      pageChanged: false,
      hasPreferences: false,
      readAriaLive: true,
      refreshPageKey: 0,
      refreshPageTopKey: 0
    };
  },
  props: ["electionId"],
  methods: {
    async getElection() {
      // console.log("Getting election %s", this.electionId);

      let election = await this.$store.state.ceoCbbService.getElection(
        this.$store.state.voterIdentification.EventIdentifier.Id,
        this.electionId,
        this.$store.state.voterIdentification.Voter.VoterIdentifier.VoterId[0]
      );

      if (election.error) {
        //console.error(election.error);
        alert(election.error + "\n\n" + this.$store.state.alertMessage);
        return;
      }

      this.election = election;
      this.electionType = election.Election[0].ElectionType;
      this.listOrCandidates =
        election.Election[0].ElectionVotingContest.ChoiceType;
      let contestList = this.election.Election[0].ElectionVotingContest.ChoicesContestIdentifier.map(
        id => {
          return { Id: id.Id, Category: id.Category };
        }
      );
      let candidates = [];
      let contest = null;
      for (const c of contestList) {
        contest = await this.getContest(c.Id);
        candidates = candidates.concat(contest);
      }
      this.candidates = candidates;
      this.loaded = true;
      this.$emit("progressbar-loaded");
      this.totCandidatesOrAffiliations = candidates.length;
    },
    hideKeyboard() {
      document.activeElement.blur();
    },
    scrollToElement(options) {
      const el = this.$el.getElementsByClassName("input-focus")[0];
      el.scrollIntoView(options);
    },
    noScroll() {
      if (document.getElementById("preference-modal") === null)
        document
          .getElementById("election-modal")
          .setAttribute("aria-hidden", "true");
      else
        document
          .getElementById("preference-modal")
          .setAttribute("aria-hidden", "true");

      this.lastFocus = document.activeElement;
      if ((this.sexVoted == 1 || this.sexVoted == -1) && this.confirmEqual) {
        this.lastEqOppFocus = document.activeElement;
      }
      this.hidediv = true;
      this.$forceUpdate();
    },
    scroll() {
      if (document.getElementById("preference-modal") === null)
        document
          .getElementById("election-modal")
          .setAttribute("aria-hidden", "false");
      else
        document
          .getElementById("preference-modal")
          .setAttribute("aria-hidden", "false");

      this.hidediv = false;
      this.lastFocus.focus();
      if ((this.sexVoted == 1 || this.sexVoted == -1) && this.confirmEqual) {
        this.lastEqOppFocus.focus();
      }
      if (this.finalConfirmCancel) {
        this.lastVoteFocus.focus();
        this.finalConfirmCancel = false;
      }
      this.$forceUpdate();
    },
    lastClick() {
      if (this.voteBlank || this.voteNull) {
        this.lastVoteFocus = document.activeElement;
      }
    },
    lastClickVote(evt) {
      this.vote(evt);
      this.lastVoteFocus = document.activeElement;
    },
    readPageFocus(val) {
      if (val) {
        this.refreshPageKey++;
        this.refreshPageTopKey++;
      } else {
        this.refreshPageKey--;
        this.refreshPageTopKey--;
      }
      this.$forceUpdate();
    },
    handleContestTabNavigation(e) {
      let focusable = document
        .querySelector("#election-modal2")
        .querySelectorAll("a,button:enabled");

      if (focusable.length) {
        let last = focusable[focusable.length - 1];
        let shift = e.shiftKey;
        if (shift) {
          this.handleTabCandidatesNavigation(e);
        } else {
          if (e.target === last) {
            e.preventDefault();
          } else {
            this.handleTabCandidatesNavigation(e);
          }
        }
      }
    }
  },
  components: {
    Candidate,
    Affiliation,
    NoAllPreferenceDialog,
    FinalConfirmVote
    // EqualOppDialog
  }
};
</script>
<style scoped>
.title-alert {
  font-weight: bold;
  font-size: 16px;
  padding: 22px;
  background: #fff3cd;
  border-radius: var(--br);
  background-color: var(--pcolor);
  margin: 30px 30px 10px 30px;
  color: #fff;
  flex: 1 1 100%;
}

.dialog {
  height: 100%;
  width: 100%;
  max-height: 100%;
  max-width: 100%;
}

.toolbar {
  border-top: 2px solid #ddd;
  position: sticky;
  bottom: 0px;
  background: #fff;
  z-index: 9999;
}
.md-dialog2 {
  width: 50%;
  height: 50%;
  max-width: 50%;
  max-height: 50%;
  overflow: auto;
}
.fullsize {
  width: 100% !important;
  max-width: 100% !important;
}
.mg {
  margin: 10px;
  padding: 5px;
}

.search-w {
  float: left !important;
  margin-bottom: 20px !important;
  margin-left: 20px;
  margin-right: 80px;
  width: 65%;
  margin-top: 10px;
  background: var(--pcolor);
  border-radius: var(--br);
  padding: 10px 20px;
}

.search-w ::placeholder {
  color: #fff;
  opacity: 1; /* Firefox */
}

.search-w.disabled {
  background: #ccc;
}
.search-w.disabled ::placeholder {
  color: #ccc;
}

.check-w {
  float: left !important;
  margin-right: 10px;
  width: 20%;
  margin-top: 15px;
}

.md-layout-item {
  flex: none;
  width: 100%;
  text-align: center;
}

.md-layout-item.md-size-100 {
  min-width: 100%;
  max-width: 100%;
  margin-left: 0 !important;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  color: #fff !important;
  background-color: var(--pcolor) !important;
}

.fullsize {
  width: 100% !important;
  max-width: 100% !important;
  float: left !important;
}

.md-icon-button {
  border-radius: 0 !important;
  z-index: 9999999885 !important;
  right: 30px !important;
  top: -20px !important;
}

.md-title {
  font-size: 12px !important;
  letter-spacing: 0;
  line-height: 12px !important;
}

.md-tabs.md-theme-default .md-tabs-indicator {
  background-color: var(--pcolor) !important;
  background-color: var(
    --md-theme-default-primary-on-background,
    var(--pcolor)
  );
}

.md-tabs.md-theme-default .md-tabs-navigation .md-button.md-active {
  color: var(--pcolor) !important;
  color: var(--md-theme-default-primary-on-background, var(--pcolor));
}

.vota {
  margin-bottom: 20px;
  min-width: 120px;
}

.md-field.md-theme-default.md-disabled .md-input {
  color: #aaa;
  -webkit-text-fill-color: #aaa;
}

.preferenze-label {
  font-weight: bold;
  font-size: 14px;
  color: var(--pcolor) !important;
  padding-top: 8px;
}

.md-size-50 {
  min-width: 33% !important;
  max-width: 33% !important;
  flex: 0 1 33% !important;
}
.size-50 {
  min-width: 50% !important;
  max-width: 50% !important;
  flex: 0 1 50% !important;
}

.help-text {
  text-align: left;
  margin-left: 20px;
  font-size: 16px;
  margin-top: 0;
  margin-bottom: 0;
}

.paginator {
  margin: 0 auto;
}
ul {
  list-style: none;
  padding: 0;
}

li {
  display: inline;
}
button.page-link {
  display: inline-block;
}
button.page-link {
  font-size: 18px;
  color: var(--pcolor);
  background-color: white;
  font-weight: 500;
  border: 1px solid;
  width: 120px;
  text-transform: none;
}
button.page-link.selected {
  background: var(--pcolor);
  color: #fff;
}
.offset {
  width: 500px !important;
  margin: 20px auto;
}
.num-page {
  margin-top: 20px;
  font-size: 16px;
}
.num-page-top {
  padding-bottom: 5px;
  font-size: 16px;
}
.content-light-w {
  background-color: #f5f5f5;
  padding-top: 15px;
}

.md-button {
  border-radius: var(--brb);
}

.search-w input:disabled {
  background: #ccc;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-accent {
  background-color: #fff !important;
  border: 1px solid var(--pcolor);
  color: var(--pcolor);
  box-shadow: none;
}
@media screen and (max-width: 750px) {
  .search-w {
    float: left !important;
    margin-bottom: 10px !important;
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    margin-top: 10px !important;
  }

  .check-w {
    width: 100%;
    margin: 0 auto;
  }
}

.no-selection {
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */
}

.search-w input {
  width: 90%;
  border: none;
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  background: var(--pcolor);
  color: #fff;
  border-bottom: 1px solid #fff;
  border-radius: 0;
}

.search-w input:focus {
  outline: none;
}

.search-w label {
  float: left;
  font-size: 12px !important;
  color: #555;
}

.search-w:focus-within label,
.search-w:focus-within {
  color: #448aff;
}
@media screen and (max-width: 667px) {
  .md-size-50 {
    min-width: 50% !important;
    max-width: 50% !important;
    flex: 0 1 50% !important;
  }

  .vota-container {
    margin: 0 auto;
  }

  .search-w label {
    font-size: 14px;
  }
  .help-text {
    margin-left: 0px;
  }

  .title-alert {
    font-weight: bold;
    font-size: 16px;
    padding: 12px;
    background: #fff3cd;
    border-radius: var(--br);
    background-color: var(--pcolor);
    margin: 15px 5px 16px;
    color: #fff;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
    text-align: center;
    font-size: 16px;
  }

  .md-mini {
    width: 160px;
  }
}
</style>
